import { defaultDraftFrameResponse, draftFrameHandler } from 'mocks/server/utils/draftFrameHandler';
import {
  defaultDraftLinkedAssetResponse,
  draftLinkedAssetHandler,
} from 'mocks/server/utils/draftLinkedAssetHandler';
import { IDraftEntityResponse, IDraftFrame, IDraftLinkedAsset } from 'types/detailsEntityType';
import { EntityType } from 'types/entityType';

const handleDraftFrame = (draftFrame: IDraftFrame): IDraftEntityResponse => {
  if (draftFrameHandler[draftFrame.spaceId]) {
    return draftFrameHandler[draftFrame.spaceId](draftFrame);
  }
  return defaultDraftFrameResponse(draftFrame);
};

const handleDraftLinkedAsset = (draftLinkedAsset: IDraftLinkedAsset): IDraftEntityResponse => {
  if (draftLinkedAssetHandler[draftLinkedAsset.spaceId]) {
    return draftLinkedAssetHandler[draftLinkedAsset.spaceId](draftLinkedAsset);
  }
  return defaultDraftLinkedAssetResponse(draftLinkedAsset);
};

export const handleDraftEntity = (
  entity: IDraftFrame | IDraftLinkedAsset,
  entityType: EntityType
): IDraftEntityResponse => {
  if (entityType === EntityType.FRAME) {
    return handleDraftFrame(entity as IDraftFrame);
  }
  return handleDraftLinkedAsset(entity as IDraftLinkedAsset);
};
